var _use, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarThick = function SvgCalendarThick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 18"
  }, props), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CalendarThick_svg__a",
    fill: "currentColor",
    transform: "translate(1.634 5.59)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-386 -1114)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "CalendarThick_svg__c"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CalendarThick_svg__b",
    fill: "#fff",
    transform: "translate(386 1114)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#CalendarThick_svg__c)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CalendarThick_svg__d",
    fill: "currentColor",
    transform: "translate(386 1114)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-386 -1114)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "CalendarThick_svg__f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CalendarThick_svg__e",
    fill: "#fff",
    transform: "matrix(1 0 0 -1 386 1119)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#CalendarThick_svg__f)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CalendarThick_svg__g",
    fill: "currentColor",
    transform: "matrix(1 0 0 -1 386 1119)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "CalendarThick_svg__a",
    d: "m2.515 7.094.543-.364q.278.743 1.028.743a.86.86 0 0 0 .648-.27q.262-.273.262-.96 0-.649-.309-.884a1.14 1.14 0 0 0-.715-.234h-.289v-.566h.29q.347 0 .624-.247.278-.25.278-.773 0-.512-.223-.746a.75.75 0 0 0-.566-.234q-.634 0-.91.742l-.544-.36q.551-.987 1.457-.988.646 0 1.047.434.407.434.407 1.152 0 .96-.793 1.3.914.259.914 1.403 0 .9-.446 1.367-.445.465-1.129.465-1.023 0-1.574-.98M8.257 8V2.84l-1.12.879-.301-.508 1.496-1.172h.593V8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CalendarThick_svg__b",
    d: "M0 0h16v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CalendarThick_svg__d",
    d: "M0 0v-2h-2v2zm16 0h2v-2h-2zm0 18v2h2v-2zM0 18h-2v2h2zM0 2h16v-4H0zm14-2v18h4V0zm2 16H0v4h16zM2 18V0h-4v18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CalendarThick_svg__e",
    d: "M0 0h16v5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CalendarThick_svg__g",
    d: "M0 0v-2h-2v2zm16 0h2v-2h-2zm0 5v2h2V5zM0 5h-2v2h2zm0-3h16v-4H0zm14-2v5h4V0zm2 3H0v4h16zM2 5V0h-4v5z"
  }))));
};
export default SvgCalendarThick;